import React, { useEffect, useState, useRef } from 'react';
import List from '@mui/material/List';
import { generateId } from '../../services/random';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ListItemButton from '@mui/material/ListItemButton';
import RequestSongbookPosition from '../items/RequestSongbookPosition';
import PerformanceSongPosition from '../items/PerformanceSongPosition';
import PerformanceListItem from '../items/PerformanceListItem';
import IntervalService from './../../services/intervals';
import EditPerformance from '../dialogs/EditPerformance';
import singersStore from './../../stores/singers';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import favoritesStore from './../../stores/favorites';
import settingsStore from '../../stores/settings';
import playerStore from './../../stores/player';

function SongbookPositionRequestList(props) {

  const [olderPosition, setOlderPosition] = useState(null);
  const [currentPosition, setCurrentPosition] = useState(null);

  const handleChoosePosition = (pos) => {
    console.log("handleChoosePosition", pos)
    if ((!currentPosition && currentPosition != 0) && (!olderPosition && olderPosition != 0)) {
      setCurrentPosition(pos);
    } else {
      setOlderPosition(currentPosition);
      setCurrentPosition(pos);
    }
    props.onChoosePosition(pos);
  };


  const performanceList = () => {
    if (props.performances) {
      let augPerformances = structuredClone(props.performances);
      let initialPerformance = null;
      let selectedPerformance = currentPosition;
      console.log("rrequests", props.requests)
      if (currentPosition || currentPosition == 0) {
        if (currentPosition < props.performances.length) {
          for (let i = 0; i < props.requests.length; i++) {
            let req = props.requests[i];
            augPerformances.splice(currentPosition + i, 0, {
              unique_id: generateId(8),
              track: req.performance.track,
              position: currentPosition + i,
              profile: req.performance.profile
            });
          }
        } else {
          for (let i = 0; i < props.requests.length; i++) {
            let req = props.requests[i];
            augPerformances.splice(props.performances.length + i, 0, {
              unique_id: generateId(8),
              track: req.performance.track,
              position: props.performances.length + i,
              profile: req.performance.profile
            });
          }
        }
      }
      console.log("selected", selectedPerformance, props.requests.length, augPerformances)
      if (currentPosition >= props.performances.length) {
        selectedPerformance = props.performances.length;
      }
      for (let i = 0; i < augPerformances.length; i++) {
        augPerformances[i].position = i;
      }
      return augPerformances.map((performance, index) =>
        <RequestSongbookPosition
          key={index}
          index={index}
          performance={performance}
          requestsLength={props.requests.length}
          length={augPerformances.length}
          performanceInitial={initialPerformance}
          performanceSelected={selectedPerformance}
          onChoosePosition={() => {
            if (performance.position == 0) {
              handleChoosePosition(0);
            } else {
              if (currentPosition || currentPosition == 0) {
                if (currentPosition < performance.position) {
                  handleChoosePosition(performance.position - props.requests.length);
                } else {
                  handleChoosePosition(performance.position);
                }
              } else {
                handleChoosePosition(performance.position);
              }
            }
          }}
        />
      );
    }
  };

  return (
    <div style={{ padding: 0 }}>
      <List className="muvika-song-position-list muvika-performance-list">
        {performanceList()}
        <ListItemButton className="muvika-song-position-hovering" onClick={() => {
          handleChoosePosition(props.performances.length);
        }}>
        </ListItemButton>
      </List>
    </div>
  );
}

export default SongbookPositionRequestList;

